var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import APLabelWithText from '../APLabelWithText';
import './SidePaneDetails.css';
var bemClasses = getBEMClasses('sidepane-details');
var SidePaneDetailsComponent = function (_React$Component) {
  _inherits(SidePaneDetailsComponent, _React$Component);
  function SidePaneDetailsComponent() {
    _classCallCheck(this, SidePaneDetailsComponent);
    return _possibleConstructorReturn(this, (SidePaneDetailsComponent.__proto__ || Object.getPrototypeOf(SidePaneDetailsComponent)).apply(this, arguments));
  }
  _createClass(SidePaneDetailsComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        title = _props.title,
        items = _props.items,
        info = _props.info,
        infoHeader = _props.infoHeader,
        classModifiers = _props.classModifiers,
        link = _props.link;
      var isHtmlString = typeof info === 'string';
      return React.createElement(React.Fragment, null, React.createElement('header', {
        className: bemClasses('header', classModifiers)
      }, title), React.createElement('section', {
        className: bemClasses('body')
      }, items && items.map(function (_ref) {
        var label = _ref.label,
          text = _ref.text;
        return React.createElement(APLabelWithText, {
          key: label,
          label: label,
          text: text,
          customClass: bemClasses()
        });
      })), items === undefined || items.length === 0 ? React.createElement('div', {
        className: bemClasses('divider')
      }) : null, React.createElement('section', {
        className: bemClasses('information', classModifiers)
      }, infoHeader && React.createElement('div', {
        className: bemClasses('information-header')
      }, infoHeader), info && (isHtmlString ? React.createElement('div', {
        dangerouslySetInnerHTML: {
          __html: info
        }
      }) : info.map(function (item, index) {
        return React.createElement('div', {
          className: bemClasses('information-text', classModifiers),
          key: index
        }, item);
      })), link && React.createElement('a', {
        href: link.url
      }, ' ', this.context.t(link.text), ' ')));
    }
  }]);
  return SidePaneDetailsComponent;
}(React.Component);
SidePaneDetailsComponent.defaultProps = {
  link: {
    text: '',
    url: ''
  }
};
SidePaneDetailsComponent.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  info: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  infoHeader: PropTypes.string,
  link: PropTypes.object
};
SidePaneDetailsComponent.getItem = function (label, text) {
  return {
    label: label,
    text: text
  };
};
SidePaneDetailsComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default SidePaneDetailsComponent;